export const DOKBOT_KIT_ID = '@doxyme/kit';
export const DOKBOT_KIT_URL = 'https://doxy.me/assets/doxybot/v1.0.2-20200914/doxybot-kit.umd.min.js';
export const DOKBOT_TYPE_CUSTOM = 'Custom Survey';
export const DOKBOT_TYPE_POSTCALL = 'Post Call Survey';
export const DOKBOT_TYPE_PRECALL = 'Pre Call Survey';
export const DOKBOT_TYPE_CHECKIN = 'Check in Survey';
